import ProfileGallerySummary from "./ProfileGallerySummary";

export default ProfileGallerySummary;
